import { darken } from 'polished';
import styled from 'styled-components';
import { C as Container } from './index.styled2.js';
import { I as Input } from './index.styled7.js';

/**
 * @license
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 */
var Wrapper = styled.div.attrs({
  className: 'gz-checkbox__wrapper',
  'aria-hidden': true
}).withConfig({
  componentId: "gz-checkbox-1679041957665__sc-1u1da3s-0"
})(["align-items:center;border:1px solid #b6b6b6;border-radius:4px;color:#fff;cursor:pointer;display:inline-flex;flex-shrink:0;height:16px;justify-content:center;transition:background-color 120ms ease 0s,border-color 120ms ease 0s;user-select:none;width:16px;", "[aria-invalid=\"true\"] + &{border-color:#f00314;}", ":hover > ", "[aria-invalid=\"true\"]:not([checked]) + &{border-color:#b6b6b6;}", "[aria-invalid=\"true\"]:disabled + &,", ":disabled + &{background-color:#b6b6b6;border-color:#b6b6b6;cursor:not-allowed;}", "[checked] + &{background-color:#314fff;border-color:", ";}", "[aria-invalid=\"true\"][checked] + &{background-color:#f00314;border-color:", ";}", "[aria-invalid=\"true\"][checked]:disabled + &,", "[checked]:disabled + &{background-color:#b6b6b6;border-color:#b6b6b6;}"], Input, Container, Input, Input, Input, Input, darken(0.05, '#314fff'), Input, darken(0.05, '#f00314'), Input, Input);

export { Wrapper as W };
